<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Спортивное питание</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <p style="margin-top:2%;">&nbsp;Спортивное питание</p>
          </div>
        </div>
      </div>
    </section>
  </main>

</template>

<script>
export default {
  name: 'sportpitanie'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/sportpitanie.vue